/**
 * Engagement list search & filter config.
 * Structured so it can later be moved to a shared list-search contract (Approach 1).
 * When generalizing: move this type to e.g. src/types/listSearch.ts and have each
 * module (engagement, referral, patient) export a config that implements it.
 */

export interface ListSearchFilterOption {
  value: string;
  label: string;
}

/** Filter dimension config; can be extended with options from API later */
export interface ListSearchFilterConfig {
  key: string;
  label: string;
  options?: ListSearchFilterOption[];
}

export interface ListSearchConfig {
  /** Placeholder / hint for the search field (e.g. "Search by name, MRN, engagement number") */
  searchableHint: string;
  /** Terms that are not searchable; user is guided when they type these (lowercase for comparison) */
  reservedSearchTerms: string[];
  /** Filter dimensions (status, scope, stage) */
  filters: ListSearchFilterConfig[];
}

/** Engagement-specific config. Other modules would define their own config with the same shape. */
export const engagementListSearchConfig: ListSearchConfig = {
  searchableHint: 'Search by name, MRN or engagement number',
  reservedSearchTerms: ['assign'],
  filters: [
    {
      key: 'workflowStatus',
      label: 'Status',
      options: [
        { value: '', label: 'All' },
        { value: 'Open', label: 'Open' },
        { value: 'Close', label: 'Closed' },
      ],
    },
    {
      key: 'workflowScope',
      label: 'Scope',
      options: [{ value: '', label: 'All' }],
    },
    {
      key: 'workflowStageName',
      label: 'Stage',
      options: [{ value: '', label: 'All' }],
    },
  ],
};

/** Check if the current search value is a reserved (non-searchable) term */
export function isReservedSearchTerm(
  value: string,
  config: ListSearchConfig = engagementListSearchConfig
): boolean {
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) return false;
  return config.reservedSearchTerms.some((term) => term.toLowerCase() === trimmed);
}
